
































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import Report from '@/views/report/index.vue';
import { AppModule } from '@/store/modules/app';
import { formatApiError, stringToNumber } from '@/utils/index';
import { productById } from '@/utils/product';
import { ProductTypeEnum, ReportAggregationGroupEnum } from '@/api/types';
import { list_product_summaries, listProductSummaries } from '@/api/product';

// const propTickets = 'tickets';
const propGroups = 'groups';
const propYear = 'year';

type ItemType = {
  text: string;
  value: string;
};

@Component({
  name: 'ReportStepTickets',
})
export default class extends Vue {
  @Prop({ default: false }) vertical!: boolean;
  @Prop({ required: true }) year!: number;
  // @PropSync(propTickets) syncTickets!: string[];
  @PropSync(propGroups) syncGroups!: string[];
  private valid = false;
  private products: Map<string, list_product_summaries.Product> = new Map();
  // private ticketItems: ItemType[] = [];
  // private ticketsRules: ((v: ItemType[]) => boolean | string)[] = [];
  private groupItems: ItemType[] = [];
  private groupsRules: ((v: ItemType[]) => boolean | string)[] = [];

  get appLanguage() {
    return AppModule.language;
  }

  get reportPreviousStepEvent() {
    return Report.reportPreviousStepEvent;
  }

  get reportNextStepEvent() {
    return Report.reportNextStepEvent;
  }

  get canNextStep() {
    return this.valid;
  }

  created() {
    this.loadRules();
  }

  mounted() {
    this.fetchData();
  }

  @Watch('appLanguage')
  private onLangSelected() {
    // this.loadTicketItems();
    this.loadGroupItems();
    (this.$refs.form as any).resetValidation();
  }

  private loadRules() {
    // this.ticketsRules = [
    //   (v: ItemType[]) =>
    //     (!!v && v.length > 0) ||
    //     (this.$t('{msg} is required', {
    //       msg: this.$t('Tickets'),
    //     }) as string),
    // ];
    this.groupsRules = [
      (v: ItemType[]) =>
        (!!v && v.length > 0) ||
        (this.$t('{msg} is required', {
          msg: this.$t('Report aggregation group'),
        }) as string),
    ];
  }

  private async fetchData() {
    AppModule.StartProgress();
    try {
      // const listProductsRes = await listProductSummaries({
      //   types: Object.values(ProductTypeEnum).filter(
      //     t => (t as ProductTypeEnum) !== ProductTypeEnum.UNKNOWN_PRODUCT_TYPE // TODO: check whether correct
      //   ),
      //   fiscalYears: [stringToNumber(this.year)!],
      //   includeInactive: true,
      // } as list_product_summaries.Request);
      // this.products = productById(listProductsRes.products);
      // this.loadTicketItems();
      this.loadGroupItems();

      AppModule.StopProgress();
    } catch (err) {
      AppModule.StopProgress();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: (this.$t('Tickets') as string).toLowerCase(),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  // private loadTicketItems() {
  //   this.ticketItems = [];
  //   this.products.forEach(p => {
  //     if ((p.type as ProductTypeEnum) === ProductTypeEnum.REAL_TICKET) {
  //       this.ticketItems.push({
  //         text: this.getProductName(p),
  //         value: p.id,
  //       });
  //     }
  //   });
  // }

  private loadGroupItems() {
    this.groupItems = Object.values(ReportAggregationGroupEnum)
      .filter(
        g =>
          (g as ReportAggregationGroupEnum) !==
          ReportAggregationGroupEnum.UNKNOWN_REPORT_AGGREGATION_GROUP
      )
      .map(g => ({
        text: this.$t(`ReportAggregationGroupEnum.${g}`) as string,
        value: g,
      }));
  }

  private getProductName(product: list_product_summaries.Product) {
    return `${
      this.$i18n.locale !== 'ja' && this.products.get(product.id)!.nameEn
        ? this.products.get(product.id)!.nameEn
        : this.products.get(product.id)!.name
    }${
      this.products.get(product.id)!.fiscalYear === 0
        ? ''
        : ' [' + this.products.get(product.id)!.fiscalYear + ']'
    }`;
  }
}
